define(['app/modules/applicant', 'app/modules/pdf_viewer', 'app/modules/applicant_upload_modal'], (
  Applicant,
  PdfViewer,
  ApplicantUploadModal
) => {
  const Applicants = function() {};

  Applicants.prototype.actionCv_viewer = function() {
    const canvasContainer = document.getElementById('pdf-container');
    const url = canvasContainer.getAttribute('data-url');

    PdfViewer.renderPDF(url, canvasContainer);

    $('.zoom-in').on('click', e => {
      e.preventDefault();
      PdfViewer.zoomIn(canvasContainer);
    });

    $('.zoom-out').on('click', e => {
      e.preventDefault();
      PdfViewer.zoomOut(canvasContainer);
    });
  };

  Applicants.prototype.actionIndex = function() {
    ApplicantUploadModal.init();
  };

  return Applicants;
});
